if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        
        // 🚨 CRITICAL FIX: DO NOT enable variant input if product has Size option
        if (this.form.querySelector('[name=id]')) {
          const hasSizeOption = this.form.querySelectorAll('input[name="Size"]').length > 0 || 
                                this.form.querySelector('select[name="options[Size]"]') !== null;
          
          if (!hasSizeOption) {
            // Only enable if no Size option exists
            this.form.querySelector('[name=id]').disabled = false;
          } else {
            // Keep disabled if Size option exists
            console.log('🔒 Keeping variant input disabled - product has Size option');
          }
        }
        
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        // 🚨 CRITICAL: Check size selection FIRST
        const sizeInputs = this.form.querySelectorAll('input[name="Size"]:not(.disabled)');
        const sizeSelect = this.form.querySelector('select[name="options[Size]"]');
        
        if (sizeInputs.length > 0 || sizeSelect) {
          let sizeSelected = false;
          
          sizeInputs.forEach(input => {
            if (input.checked) sizeSelected = true;
          });
          
          if (sizeSelect && sizeSelect.value && sizeSelect.value !== '' && sizeSelect.value !== 'Please select a size') {
            sizeSelected = true;
          }
          
          if (!sizeSelected) {
            console.log('❌ product-form.js: Blocking - no size selected');
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            
            // Show alert
            const existing = document.querySelector('.size-selection-alert');
            if (existing) existing.remove();
            
            const alert = document.createElement('div');
            alert.className = 'size-selection-alert';
            alert.style.cssText = `
              position: fixed;
              top: 20px;
              left: 50%;
              transform: translateX(-50%);
              z-index: 99999;
              background: #fff3cd;
              border: 2px solid #ffc107;
              border-radius: 8px;
              padding: 15px 25px;
              box-shadow: 0 4px 12px rgba(0,0,0,0.15);
              display: flex;
              align-items: center;
              gap: 12px;
              color: #856404;
              font-size: 15px;
              font-weight: 600;
              max-width: 90%;
            `;
            
            alert.innerHTML = `
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"/>
              </svg>
              <span>👉 Please select a size before proceeding.</span>
            `;
            
            document.body.appendChild(alert);
            
            setTimeout(() => {
              alert.style.opacity = '0';
              alert.style.transition = 'opacity 0.3s';
              setTimeout(() => alert.remove(), 300);
            }, 4000);
            
            return false;
          }
        }
        
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (this.submitButton.id != "ProductSubmitButton-product-quickview") {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const is_cart_page = document.body.classList.contains('template-cart');
            if (!is_cart_page) {
              this.cart.renderContents(response);
            }else{
              closePopup.hide();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}